import { render } from "./LanguageUnit.vue?vue&type=template&id=53aa7897&scoped=true"
import script from "./LanguageUnit.vue?vue&type=script&lang=js"
export * from "./LanguageUnit.vue?vue&type=script&lang=js"

import "./LanguageUnit.vue?vue&type=style&index=0&id=53aa7897&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53aa7897"]])

export default __exports__